document.addEventListener('DOMContentLoaded', () => {
  function animateSection(sectionClass) {
    const sections = document.querySelectorAll(`.${sectionClass}`);
    if (!sections.length) return;

    const observer = new IntersectionObserver((entries, obs) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('show'); // add to div, not img
          obs.unobserve(entry.target);       // animate only once
        }
      });
    }, { threshold: 0.2 });

    sections.forEach(section => observer.observe(section));
  }

  // Animate your two image blocks
  animateSection('image-block--AMnFJbUx5R1FHWDVHW__image_HFp4DD');
  animateSection('image-block--AaVI3KzMzV0UzdXpjT__image_MAHdyT');
  animateSection('text-block--ANXkzYVlpMHZWelJ6S__text_VVdBUc');
  animateSection('text-block--AdW9IbGs5Qlg2RUI0a__text_xFCjwi');
  animateSection('button--AMDBZWWgyMms2RDFZL__button_PecKDE');
  animateSection('image-block--AbGJ1MU9Ic3dnTGRWN__image_RPxVNK');
  animateSection('text-block--AajdWRzNKVXFPZC9xe__text_BGdADp');
  animateSection('button--ALzB1bi8xZGJ2OHJOR__button_NUYbXU');
  animateSection('text-block--AcGFyMERLN0RHdm5GT__text_JPa7he');
  animateSection('text-block--AUzdhZW84bVpwM1BLb__text_qDpK4N');
  animateSection('button--AZE9ZTUcwNTNuQ0x3d__button_r6c6FK');
  animateSection('media-block--AK1JyY3h2Q3RZT3FpW__media');
  animateSection('group-block--AMzA2MTZta0ZNWHdia__group_CHBNff');
  animateSection('image-block--Ad3VPWkw3VWJ4R2x5b__image_TBNDCG');
  animateSection('image-block--AdnNLNGl3cG1GbGZNV__image_8w8naG');
  animateSection('group-block--AWGxrUnEwdkRjWnlIQ__group_qDNH73');
  animateSection('image-block--AcmtnYUNRUzZDZTh6R__image_JpGFjP');
  animateSection('group-block--AaXBGOFhOVEdKRU85T__group_QCwEid');
  animateSection('image-block--ATzE0NWpPaitvM2l0M__image_RPxVNK');
  animateSection('text-block--ANHNwdEIxbmNhYUdyY__text_BGdADp');
  animateSection('button--ATC9RaVdJSHA0clZLc__button_NUYbXU');
  animateSection('media-block--AODNKOUw5QWNBVFYvS__media');
  animateSection('group-block--AWFQrdjFORTIreEJwW__group_wBMJ3q');
  animateSection('media-block--AT1BUcDA0b0lHUEZUZ__media');
  animateSection('group-block--AUWRMZXpaSzBCdTdTR__group_E3EqjK');
  animateSection('group-block--ATG9UU3NaVU1TRm03R__group_wBMJ3q');
  animateSection('media-block--ATS9QTkdtNXFKMHBUU__media');
  animateSection('media-block--AdUJuVy9yMW5kdC91M__media');
  animateSection('group-block--ARkxxZnBiNFVWTm82L__group_E3EqjK');
  animateSection('image-block--AaDNheEFzSUdQN0VDQ__image_7zEteV');
  animateSection('text-block--ARUV1K05sMkVKWE8vS__text_xDWpmY');
  animateSection('button--AcHY5MFcvelNCNi9hc__button_MrGXbV');
  animateSection('image-block--AWE9CcDE5TFIzakczU__image_93QiCV');
  animateSection('group-block--AYkkxeTVOVUVJVHZBY__group_XWmqBK');
  animateSection('artist-title');
  animateSection('artist-card');
  animateSection('dcg-title');
  animateSection('dcg-card');
  animateSection('media-block--AWkhXdnBCaDR2RkVja__media');
  animateSection('group-block--ATzZFbTZhTjJNeUJYK__group_VaNLXz');
  animateSection('media-gallery__grid');
  animateSection('group-block--AbVg5bzlSamtoVzhjc__product-details');
  animateSection('crp-title');
  animateSection('crp-card');
  animateSection('image-block--AS00wTU1kVkF5ZEthS__image_7zEteV');
  animateSection('text-block--AY0ova21NVndVVmxFO__text_xDWpmY');
  animateSection('email-signup-block');
});